import radarGridObjectRepository from "@/api/radar-grid/entity/radarGridObjectRepository";
import radarGridRadarBaseRepository from "@/api/radar-grid/entity/radarGridRadarBaseRepository";

const repositories = {
  radarGridObjectRepository: radarGridObjectRepository,
  radarGridRadarBaseRepository: radarGridRadarBaseRepository,
};

export const RadarGridApiFactory = {
  get: name => repositories[name],
};
